import { Globe, HeartHandshake, BadgePercent, Award, Eye, Handshake } from "lucide-react";
import { TID } from "@/lib/testIds";

const reasons = [
  {
    key: "global-network",
    Icon: Globe,
    title: "Global Network",
    desc: "Serving businesses across Asia, Europe, GCC, North America, Africa, and beyond.",
  },
  {
    key: "customer-focused",
    Icon: HeartHandshake,
    title: "Customer-Focused Service",
    desc: "Dedicated logistics specialists providing personalized support for every shipment.",
  },
  {
    key: "competitive",
    Icon: BadgePercent,
    title: "Competitive Freight Solutions",
    desc: "Optimized routing and cost-effective transportation without compromising service quality.",
  },
  {
    key: "operational",
    Icon: Award,
    title: "Operational Excellence",
    desc: "Reliable execution through experienced professionals and trusted overseas partners.",
  },
  {
    key: "visibility",
    Icon: Eye,
    title: "End-to-End Visibility",
    desc: "From booking to final delivery, we keep you informed at every stage of the shipment.",
  },
  {
    key: "partnerships",
    Icon: Handshake,
    title: "Trusted Partnerships",
    desc: "Long-term relationships built on transparency, consistency, and exceptional service.",
  },
];

export default function WhyChoose() {
  return (
    <section
      id="services"
      data-testid={TID.services.section}
      className="bg-white border-t border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12 md:mb-16">
          <div className="md:col-span-6 reveal">
            <p className="text-sm font-bold uppercase tracking-[0.25em] text-sky-600 mb-4">
              Why Choose JMR Global Logistics
            </p>
            <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter text-slate-900 leading-[1.02]">
              Six reasons<br />
              <span className="text-slate-400">to partner with us.</span>
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 flex items-end reveal">
            <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
              Every shipment represents your business, your customers, and your reputation. We deliver each one with precision, reliability, and care — because your success is our priority.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
          {reasons.map((r, i) => (
            <article
              key={r.key}
              data-testid={TID.services.item(r.key)}
              className="group relative bg-white p-8 md:p-10 hover:bg-sky-50/60 transition-colors reveal"
            >
              <div className="flex items-start justify-between mb-6">
                <span className="inline-flex items-center justify-center w-12 h-12 bg-sky-100 text-blue-700 group-hover:bg-sky-400 group-hover:text-white transition-colors">
                  <r.Icon className="w-6 h-6" strokeWidth={1.6} />
                </span>
                <span className="font-mono text-xs text-slate-400 tracking-widest">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <h3 className="font-display font-bold text-2xl md:text-3xl text-slate-900 mb-3 leading-tight">{r.title}</h3>
              <p className="text-slate-600 text-base md:text-lg leading-relaxed">{r.desc}</p>
              <div className="absolute bottom-0 left-0 h-0.5 w-0 bg-sky-500 group-hover:w-full transition-all duration-500" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
